import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { ISearchParameters, Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  IUserInsReport,
  IDeltaHedgeExeCommonSearchParam,
  IInsReport,
  IDetailProcessSahraOrderReport,
  IDetailProcessReport,
  IDeltaProccessSahraOrderSearchParam,
  IIncrementalReport,
  IDecrementalReport,
  IDeltaHedgeExeManagementTableSearchParam,
  IDeltaHedgeExeManagementTableReport,
  IDeltaHedgeExeManagementAddEditTaskDTO,
  IDeltaHedgeExeTradeSearchParam,
  IDeltaHedgeExeTradeTableReport,
  IExeTimeDTO,
  IAllowedTradesSearchParam,
  IAllowedTradesTableReport,
  IDeltaHedgeExeCommonConfigDTO,
  IDeltaHedgeExeAdjustmentFromCentralConfigDTO,
  IDeltaHedgeExeEmergancyConfig,
  IDeltaHedgeExeDetailedStateTableSearchParam,
  IDeltaHedgeExeDetailedStateTableReport,
  IDeltaHedgeExeDetailedStateTradeTableSearchParam,
  IDeltaHedgeExeDetailedStateAdjustmentStateTableSearchParam,
  IDetailedStateAdjustmentTablesSearchParam,
  IDeltaHedgeExeStrategy,
} from "../Interfaces/deltaHedgeExe";
import { IOptionDomainChartsReport } from "../Interfaces/optionDomain";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  patchRequest,
  postRequest,
  putRequest,
} from "./requestTemplates";
import { AxiosRequestConfig } from "axios";

export const getUserInsTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IUserInsReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IUserInsReport>(
    "/v1/DeltaHedgeExe/UserInsTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getInsTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IInsReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IInsReport>(
    "/v1/DeltaHedgeExe/InsTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeIncrementalTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IIncrementalReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IIncrementalReport>(
    "/v1/DeltaHedgeExe/incremental",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeIncrementalChancesTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, any>(
    "/v1/DeltaHedgeExe/getIncrementalChances",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeIncrementalOrdersTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, any>(
    "/v1/DeltaHedgeExe/getIncrementalOrders",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeDecrementalTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDecrementalReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IDecrementalReport>(
    "/v1/DeltaHedgeExe/decremental",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeDecrementalChancesTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, any>(
    "/v1/DeltaHedgeExe/getDecrementalChances",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeDecrementalOrdersTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, any>(
    "/v1/DeltaHedgeExe/getDecrementalOrders",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDeltaTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IInsReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IInsReport>(
    "/v1/DeltaHedgeExe/DeltaTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );
export const getProcessTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDetailProcessReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IDetailProcessReport>(
    "/v1/DeltaHedgeExe/ProcessTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getSahraOrders = (
  searchParam: IDeltaProccessSahraOrderSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDetailProcessSahraOrderReport>> =>
  getTable<IDeltaProccessSahraOrderSearchParam, IDetailProcessSahraOrderReport>(
    "/v1/DeltaHedgeExe/SahraOrders",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getErrorTable = (
  searchParam: IDeltaHedgeExeCommonSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IInsReport>> =>
  getTable<IDeltaHedgeExeCommonSearchParam, IInsReport>(
    "/v1/DeltaHedgeExe/ErrorTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDeltaHedgeExeCentralConfig =
  (): Promise<IDeltaHedgeExeCommonConfigDTO> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeCentralSettings");

export const setDeltaHedgeExeCentralConfig = (
  dto: IDeltaHedgeExeCommonConfigDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/SetCentralSettings", dto);

export const getDeltaHedgeExeAdjustmentDeltaGammaOffsetConfig =
  (): Promise<IDeltaHedgeExeCommonConfigDTO> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeOffsetDeltaGamma");
export const setDeltaHedgeExeAdjustmentDeltaGammaOffsetConfig = (
  dto: IDeltaHedgeExeCommonConfigDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/SetOffsetDeltaGamma", dto);

export const getDeltaHedgeExeAdjustmentDeltaOffsetConfig =
  (): Promise<IDeltaHedgeExeAdjustmentFromCentralConfigDTO> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeOffsetDelta");

export const setDeltaHedgeExeAdjustmentDeltaOffsetConfig = (
  dto: IDeltaHedgeExeAdjustmentFromCentralConfigDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/SetOffsetDelta", dto);

export const getDeltaHedgeExeAdjustmentDeltaGammaInputAdjustmentConfig =
  (): Promise<IDeltaHedgeExeCommonConfigDTO> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeDeltaGammaInput");

export const setDeltaHedgeExeAdjustmentDeltaGammaInputAdjustmentConfig = (
  dto: IDeltaHedgeExeCommonConfigDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/SetDeltaGammaInput", dto);

export const getDeltaHedgeExeAdjustmentDeltaInputConfig =
  (): Promise<IDeltaHedgeExeAdjustmentFromCentralConfigDTO> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeDeltaInput");

export const setDeltaHedgeExeAdjustmentDeltaInputConfig = (
  dto: IDeltaHedgeExeAdjustmentFromCentralConfigDTO
): Promise<Packet<boolean>> => postRequest("/v1/DeltaHedge/SetDeltaInput", dto);

export const getDeltaHedgeExeAdjustmentEmergencyOffsetConfig =
  (): Promise<IDeltaHedgeExeEmergancyConfig> =>
    getRequest("/v1/DeltaHedge/GetDeltaHedgeEmergencyOffset");

export const setDeltaHedgeExeAdjustmentEmergencyOffsetConfig = (
  dto: IDeltaHedgeExeEmergancyConfig
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/SetEmergencyOffset", dto);

export const getDeltaHedgeExeManagementTable = (
  searchParam: IDeltaHedgeExeManagementTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDeltaHedgeExeManagementTableReport>> =>
  getTable<
    IDeltaHedgeExeManagementTableSearchParam,
    IDeltaHedgeExeManagementTableReport
  >(
    "/v1/DeltaHedgeExe/ExeManagementTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDeltaHedgeExeLogsTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<ISearchParameters, any>(
    "/v1/DeltaHedgeExe/ExeManagementLogs",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDeltaHedgeExeAllowedTradeLogsTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<ISearchParameters, any>(
    "/v1/DeltaHedgeExe/AllowedTradeLogsTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const addDeltaHedgeExeManagementTask = (
  dto: IDeltaHedgeExeManagementAddEditTaskDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedgeExe/AddExeManagementTask", dto);

export const editDeltaHedgeExeManagementTask = (
  dto: IDeltaHedgeExeManagementAddEditTaskDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedgeExe/EditExeManagementTask", dto);

export const deleteDeltaHedgeExeTask = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/DeltaHedgeExe/DeleteExeManagementTask?id=${id}`);

export const deltaHedgeExeAdjustmentChangeState = (
  state: any
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedgeExe/changeAdjustmentState", { state });

export const deltaHedgeExeChangeState = (
  state: any
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedgeExe/changeDeltaHedgeState", { state });

export const getDeltaHedgeExeTradeTable = (
  searchParam: IDeltaHedgeExeTradeSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeTradeSearchParam, IDeltaHedgeExeTradeTableReport>(
    "/v1/DeltaHedgeExe/TradeTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const deleteDeltaHedgeExeRemainingTrade = (
  id: number
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/DeltaHedgeExe/DeleteExeRemainingTrade?id=${id}`);

export const getDeltaHedgeExeErrorsTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<ISearchParameters, IDeltaHedgeExeTradeTableReport>(
    "/v1/DeltaHedgeExe/ErrorsTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getExeTimeInfo = (): Promise<IExeTimeDTO> =>
  getRequest("/v1/DeltaHedgeExe/getExeConfig");

export const putExeTimeInfo = (dto: IExeTimeDTO): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeExe/setExeConfig", dto);

export const getDeltaHedgeExeAllowedTradesTable = (
  searchParam: IAllowedTradesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IAllowedTradesTableReport>> =>
  getTable<IAllowedTradesSearchParam, IAllowedTradesTableReport>(
    "/v1/DeltaHedgeExe/AllowedTradeTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDeltaHedgeExeDetailedStateAdjustmentStateTable = (
  searchParam: IDeltaHedgeExeDetailedStateAdjustmentStateTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDeltaHedgeExeDetailedStateAdjustmentStateTableSearchParam, any>(
    "/v1/DeltaHedgeExe/AdjusmentStateTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const deleteDetailedStateTradeRemaining = (
  id: number
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/RemoveDetailedStateRemaining?id=${id}`);

export const adjustmentBulkDisable = (
  ids: number[]
): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeExe/Settings/BulkDisableAdjustment", ids);
export const adjustmentBulkEnable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeExe/Settings/BulkEnableAdjustment", ids);

export const deltaHedgeBulkDisable = (
  ids: number[]
): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeExe/Settings/BulkDisabledeltaHedge", ids);
export const deltaHedgeBulkEnable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeExe/Settings/BulkEnabledeltaHedge", ids);

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 * اطلاعات مدال هر گروه
 *
 * @param {number|string} index
 * @async
 * @version 1.4.0
 */
export const getDeltaHedgeExeGroupConfig = (
  index: number | string
): Promise<IDeltaHedgeExeCommonConfigDTO> =>
  getRequest(`/v1/DeltaHedge/GetGroupCentralSettings?index=${index}`);

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 *  ثبت اطلاعات مدال هر گروه
 *
 * @param {number|string} index
 * @param {IDeltaHedgeExeCommonConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const setDeltaHedgeExeGroupConfig = (
  index: number | string,
  dto: IDeltaHedgeExeCommonConfigDTO
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/DeltaHedge/SetGroupCentralSettingsGroup?index=${index}`,
    dto
  );

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 *  گرفتن استراتژی های موجود
 *
 * @param {number|string} index
 * @param {IDeltaHedgeExeCommonConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const getDeltaHedgeExeStrategies = (): Promise<DropdownItem[]> =>
  getRequest("/v1/DeltaHedge/GetStrategies");

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 *  اضافه استراتژی جدید
 *
 * @param {number|string} index
 * @param {IDeltaHedgeExeCommonConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const addDeltaHedgeExeStrategies = (
  strategy: IDeltaHedgeExeStrategy
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedge/AddStrategy", strategy);

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 *  حذف استراتژی
 *
 * @param {number|string} index
 * @param {IDeltaHedgeExeCommonConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const deleteDeltaHedgeExeStrategies = (
  strategyId: string
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/DeltaHedge/DeleteStrategy?strategyId=${strategyId}`);

/**
 * DeltaHedge => AdjustmentExe => ExeConfig => GroupConfig
 *  ویرایش استراتژی
 *
 * @param {number|string} index
 * @param {IDeltaHedgeExeCommonConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const editDeltaHedgeExeStrategies = (
  strategy: IDeltaHedgeExeStrategy
): Promise<Packet<boolean>> =>
  patchRequest(`/v1/DeltaHedge/EditStrategy`, strategy);

/**
 * DeltaHedge => AdjustmentExe => ExeManagement
 *  روش تعدیل :آفستی
 *
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const bulkSetAdjusmentToOffset = (
  ids: number[]
): Promise<Packet<boolean>> =>
  putRequest("v1/DeltaHedgeExe/Settings/BulkSetAdjusmentToOffset", ids);

/**
 * DeltaHedge => AdjustmentExe => ExeManagement
 *  روش تعدیل :آفستی+ورودی دارایی
 *
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const bulkSetAdjusmentToOpenPortfo = (
  ids: number[]
): Promise<Packet<boolean>> =>
  putRequest("v1/DeltaHedgeExe/Settings/BulkSetAdjusmentToOpenPortfo", ids);

/**
 * DeltaHedge => AdjustmentExe => ExeManagement
 *  روش تعدیل: آفستی+ ورودی همه
 *
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const bulkSetAdjusmentToOpen = (
  ids: number[]
): Promise<Packet<boolean>> =>
  putRequest("v1/DeltaHedgeExe/Settings/BulkSetAdjusmentToOpen", ids);
